/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HomeOwnershipKind } from './homeOwnershipKind';

/**
 * (german: Wohneigentum)   (bipro-kraftfahrt::SelbstgenutztesWohneigentum)
 */
export interface HomeOwnership {
  homeOwnership?: HomeOwnershipKind;
}
export namespace HomeOwnership {}
